/* esm.sh - unhead@2.1.12/dist/shared/unhead.CbpEuj3y */
export * from "/*unhead@2.1.12/esnext/dist/shared/unhead.CbpEuj3y.mjs";
